/* eslint-disable max-lines */
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdStylioCapsule } from './pages'

type TIdToPageMapStylioCapsule = Record<PageIdStylioCapsule, TPageMapValue>

export const ID_TO_PAGE_MAP_STYLIO_CAPSULE: TIdToPageMapStylioCapsule = {
  [PageIdStylioCapsule.AGE_CAPSULE]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsule/pages/questions/AgeQuestion').then(
        (m) => ({
          default: m.AgeQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule/pages/questions/AgeQuestion'),
  },
  [PageIdStylioCapsule.URGE_CAPSULE]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsule/pages/urge/UrgePage').then((m) => ({
        default: m.UrgePage,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_capsule/pages/urge/UrgePage'),
  },
  [PageIdStylioCapsule.HAIR_COLOR_CAPSULE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule/pages/questions/HairColorQuestion'
      ).then((m) => ({
        default: m.HairColorQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule/pages/questions/HairColorQuestion'),
  },
  [PageIdStylioCapsule.EYES_COLOR_CAPSULE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule/pages/questions/EyesColorQuestion'
      ).then((m) => ({
        default: m.EyesColorQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule/pages/questions/EyesColorQuestion'),
  },
  [PageIdStylioCapsule.JEWELRY_CAPSULE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule/pages/questions/JewelryQuestion'
      ).then((m) => ({
        default: m.JewelryQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule/pages/questions/JewelryQuestion'),
  },
  [PageIdStylioCapsule.BODY_SHAPE_CAPSULE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule/pages/questions/BodyShapeQuestion'
      ).then((m) => ({
        default: m.BodyShapeQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule/pages/questions/BodyShapeQuestion'),
  },
  [PageIdStylioCapsule.OUTFIT_STRUGGLES_CAPSULE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule/abtest/OutfitStruggles/OutfitStruggles'
      ).then((m) => ({
        default: m.OutfitStruggles,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule/abtest/OutfitStruggles/OutfitStruggles'
      ),
  },
  [PageIdStylioCapsule.STYLIO_TO_HELP_CAPSULE]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsule/pages/questions/StylioToHelp').then(
        (m) => ({
          default: m.StylioToHelp,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule/pages/questions/StylioToHelp'),
  },
  [PageIdStylioCapsule.TALL_CAPSULE]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsule/pages/questions/TallQuestion').then(
        (m) => ({
          default: m.TallQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule/pages/questions/TallQuestion'),
  },
  [PageIdStylioCapsule.WEIGHT_CAPSULE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule/pages/questions/WeightQuestion'
      ).then((m) => ({
        default: m.WeightQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule/pages/questions/WeightQuestion'),
  },
  [PageIdStylioCapsule.BODY_COMFORT_CAPSULE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule/abtest/BodyComfort/BodyComfort'
      ).then((m) => ({
        default: m.BodyComfort,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule/abtest/BodyComfort/BodyComfort'),
  },
  [PageIdStylioCapsule.WHAT_YOU_WEAR_CAPSULE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule/abtest/WhatYouWear/WhatYouWear'
      ).then((m) => ({
        default: m.WhatYouWear,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule/abtest/WhatYouWear/WhatYouWear'),
  },
  [PageIdStylioCapsule.URGE_2_CAPSULE]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsule/pages/urge/UrgePageVariant2').then(
        (m) => ({
          default: m.UrgePageVariant2,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule/pages/urge/UrgePageVariant2'),
  },
  [PageIdStylioCapsule.FEEL_ABOUT_CAPSULE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule/pages/questions/FeelAboutQuestion'
      ).then((m) => ({
        default: m.FeelAboutQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule/pages/questions/FeelAboutQuestion'),
  },
  [PageIdStylioCapsule.WARDROBE_USAGE_CAPSULE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule/abtest/WardrobeUsage/WardrobeUsage'
      ).then((m) => ({
        default: m.WardrobeUsage,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule/abtest/WardrobeUsage/WardrobeUsage'),
  },
  [PageIdStylioCapsule.NOT_ALONE_CAPSULE]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsule/abtest/NotAlone/NotAlone').then(
        (m) => ({
          default: m.NotAlone,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule/abtest/NotAlone/NotAlone'),
  },
  [PageIdStylioCapsule.PERCENTAGE_CAPSULE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule/pages/questions/PercentageQuestion'
      ).then((m) => ({
        default: m.PercentageQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule/pages/questions/PercentageQuestion'),
  },
  [PageIdStylioCapsule.SHOPPING_CAPSULE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule/pages/questions/ShoppingQuestion'
      ).then((m) => ({
        default: m.ShoppingQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule/pages/questions/ShoppingQuestion'),
  },
  [PageIdStylioCapsule.STYLE_MOST_MATTERS_CAPSULE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule/pages/questions/StyleMostMattersQuestion'
      ).then((m) => ({
        default: m.StyleMostMattersQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule/pages/questions/StyleMostMattersQuestion'
      ),
  },
  [PageIdStylioCapsule.YOUR_LOCATION_CAPSULE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule/abtest/YourLocation/YourLocation'
      ).then((m) => ({
        default: m.YourLocation,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule/abtest/YourLocation/YourLocation'),
  },
  [PageIdStylioCapsule.FAVORITE_COLORS_CAPSULE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule/pages/questions/FavoriteColorsQuestion'
      ).then((m) => ({
        default: m.FavoriteColorsQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule/pages/questions/FavoriteColorsQuestion'
      ),
  },
  [PageIdStylioCapsule.LIKE_OR_DISLIKE_CAPSULE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule/pages/likeOrDislike/LikeOrDislike'
      ).then((m) => ({
        default: m.LikeOrDislikeQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule/pages/likeOrDislike/LikeOrDislike'),
  },
  [PageIdStylioCapsule.LIKE_OR_DISLIKE_11_CAPSULE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule/pages/likeOrDislike/LikeOrDislikeVariant11'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant11Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule/pages/likeOrDislike/LikeOrDislikeVariant11'
      ),
  },
  [PageIdStylioCapsule.LIKE_OR_DISLIKE_12_CAPSULE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule/pages/likeOrDislike/LikeOrDislikeVariant12'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant12Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule/pages/likeOrDislike/LikeOrDislikeVariant12'
      ),
  },
  [PageIdStylioCapsule.LIKE_OR_DISLIKE_13_CAPSULE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule/pages/likeOrDislike/LikeOrDislikeVariant13'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant13Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule/pages/likeOrDislike/LikeOrDislikeVariant13'
      ),
  },
  [PageIdStylioCapsule.LIKE_OR_DISLIKE_14_CAPSULE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule/pages/likeOrDislike/LikeOrDislikeVariant14'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant14Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule/pages/likeOrDislike/LikeOrDislikeVariant14'
      ),
  },
  [PageIdStylioCapsule.LIKE_OR_DISLIKE_15_CAPSULE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule/pages/likeOrDislike/LikeOrDislikeVariant15'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant15Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule/pages/likeOrDislike/LikeOrDislikeVariant15'
      ),
  },
  [PageIdStylioCapsule.LIKE_OR_DISLIKE_16_CAPSULE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule/pages/likeOrDislike/LikeOrDislikeVariant16'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant16Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule/pages/likeOrDislike/LikeOrDislikeVariant16'
      ),
  },
  [PageIdStylioCapsule.LIKE_OR_DISLIKE_17_CAPSULE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule/pages/likeOrDislike/LikeOrDislikeVariant17'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant17Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule/pages/likeOrDislike/LikeOrDislikeVariant17'
      ),
  },
  [PageIdStylioCapsule.LIKE_OR_DISLIKE_18_CAPSULE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule/pages/likeOrDislike/LikeOrDislikeVariant18'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant18Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule/pages/likeOrDislike/LikeOrDislikeVariant18'
      ),
  },
  [PageIdStylioCapsule.LIKE_OR_DISLIKE_19_CAPSULE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule/pages/likeOrDislike/LikeOrDislikeVariant19'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant19Question,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule/pages/likeOrDislike/LikeOrDislikeVariant19'
      ),
  },
  [PageIdStylioCapsule.SEE_YOURSELF_CAPSULE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule/abtest/SeeYourself/SeeYourself'
      ).then((m) => ({
        default: m.SeeYourself,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule/abtest/SeeYourself/SeeYourself'),
  },
  [PageIdStylioCapsule.STYLES_FEEL_LIKE_YOU_CAPSULE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule/pages/questions/StylesFeelLikeYouQuestion'
      ).then((m) => ({
        default: m.StylesFeelLikeYouQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule/pages/questions/StylesFeelLikeYouQuestion'
      ),
  },
  [PageIdStylioCapsule.URGE_3_CAPSULE]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsule/pages/urge/UrgePageVariant3').then(
        (m) => ({
          default: m.UrgePageVariant3,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule/pages/urge/UrgePageVariant3'),
  },
  [PageIdStylioCapsule.BRAND_CAPSULE]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsule/pages/questions/BrandQuestion').then(
        (m) => ({
          default: m.BrandQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule/pages/questions/BrandQuestion'),
  },
  [PageIdStylioCapsule.FIND_NEW_CLOTHES_CAPSULE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule/pages/questions/FindNewClothesQuestion'
      ).then((m) => ({
        default: m.FindNewClothesQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule/pages/questions/FindNewClothesQuestion'
      ),
  },
  [PageIdStylioCapsule.NOTHING_TO_WEAR_CAPSULE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule/pages/questions/NothingToWearQuestion'
      ).then((m) => ({
        default: m.NothingToWearQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule/pages/questions/NothingToWearQuestion'
      ),
  },
  [PageIdStylioCapsule.OLD_CLOTHES_CAPSULE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule/pages/questions/OldClothesQuestion'
      ).then((m) => ({
        default: m.OldClothesQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule/pages/questions/OldClothesQuestion'),
  },
  [PageIdStylioCapsule.COMBINE_CLOTHES_CAPSULE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule/pages/questions/CombineClothesQuestion'
      ).then((m) => ({
        default: m.CombineClothesQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule/pages/questions/CombineClothesQuestion'
      ),
  },
  [PageIdStylioCapsule.OPTIMIZE_BUDGET_CAPSULE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule/pages/questions/OptimizeBudgetQuestion'
      ).then((m) => ({
        default: m.OptimizeBudgetQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule/pages/questions/OptimizeBudgetQuestion'
      ),
  },
  [PageIdStylioCapsule.URGE_4_CAPSULE]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsule/pages/urge/UrgePageVariant4').then(
        (m) => ({
          default: m.UrgePageVariant4,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule/pages/urge/UrgePageVariant4'),
  },
  [PageIdStylioCapsule.WHAT_YOU_WILL_FIND_CAPSULE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule/abtest/WhatYouWillFind/WhatYouWillFind'
      ).then((m) => ({
        default: m.WhatYouWillFind,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule/abtest/WhatYouWillFind/WhatYouWillFind'
      ),
  },
  [PageIdStylioCapsule.PREPARE_FLOW_CAPSULE]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsule/pages/prepareFlow/PrepareFlow').then(
        (m) => ({
          default: m.PrepareFlow,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule/pages/prepareFlow/PrepareFlow'),
  },
  [PageIdStylioCapsule.EMAIL_CAPSULE]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsule/pages/email/Email').then((m) => ({
        default: m.Email,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_capsule/pages/email/Email'),
  },
  [PageIdStylioCapsule.EMAIL_CONSENT_CAPSULE]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsule/pages/email/EmailConsent').then(
        (m) => ({
          default: m.EmailConsent,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule/pages/email/EmailConsent'),
  },
  [PageIdStylioCapsule.SUBSCRIPTIONS_CAPSULE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule/pages/subscriptions/SubscriptionPage'
      ).then((m) => ({
        default: m.SubscriptionPage,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule/pages/subscriptions/SubscriptionPage'
      ),
  },
  [PageIdStylioCapsule.CANCEL_OFFER_CAPSULE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule/pages/cancel-offer/CancelOffer'
      ).then((m) => ({
        default: m.CancelOffer,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule/pages/cancel-offer/CancelOffer'),
  },
  [PageIdStylioCapsule.SUB_UPSELL_CAPSULE]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsule/pages/sub-upsell/SubUpsell').then(
        (m) => ({
          default: m.SubUpsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule/pages/sub-upsell/SubUpsell'),
  },
  [PageIdStylioCapsule.UPSELL_CAPSULE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule/abtest/BundleUpsell/ProportionsUpsell'
      ).then((m) => ({
        default: m.ProportionsUpsell,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule/abtest/BundleUpsell/ProportionsUpsell'
      ),
  },
  [PageIdStylioCapsule.THIRD_PDF_UPSELL_CAPSULE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule/abtest/BundleUpsell/FaceUpsell'
      ).then((m) => ({
        default: m.FaceUpsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule/abtest/BundleUpsell/FaceUpsell'),
  },
  [PageIdStylioCapsule.BUNDLE_UPSELL_CAPSULE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule/abtest/BundleUpsell/BundleUpsell'
      ).then((m) => ({
        default: m.BundleUpsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule/abtest/BundleUpsell/BundleUpsell'),
  },
  [PageIdStylioCapsule.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
  [PageIdStylioCapsule.DOWNLOAD_CAPSULE]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule/pages/download-app/DownloadDefault'
      ).then((m) => ({
        default: m.DownloadDefault,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule/pages/download-app/DownloadDefault'),
  },
}
